import React from 'react';
import { useTranslation } from 'react-i18next';

import img1 from '@/assets/explore-maatra/hospitalisation-img1.png';
import img2 from '@/assets/explore-maatra/hospitalisation-img2.png';
import img3 from '@/assets/explore-maatra/hospitalisation-img3.png';
import { MAATRA_VIDEO_URL } from '@/utils/constants';

import ExploreScreen, { ExploreCard } from './ExploreScreen';

const BEIGE = 'radial-gradient(ellipse at center, rgba(236,221,184,1) 0%, rgba(245,235,225,1) 100%)';
const PINK = 'radial-gradient(ellipse at center, rgba(245,182,231,1) 0%, rgba(244,215,233,1) 100%)';
const PURPLE = 'radial-gradient(ellipse at center, rgba(209,193,237,1) 0%, rgba(242,225,245,1) 100%)';

const Hospitalisation: React.FC = () => {
  const { t } = useTranslation();

  const cards: [ExploreCard, ExploreCard, ExploreCard] = [
    { img: img1, title: t('auth.hospitalisation.cards.c1'), thumbGradient: BEIGE, videoUrl: MAATRA_VIDEO_URL },
    { img: img2, title: t('auth.hospitalisation.cards.c2'), thumbGradient: PINK, videoUrl: MAATRA_VIDEO_URL },
    { img: img3, title: t('auth.hospitalisation.cards.c3'), thumbGradient: PURPLE, videoUrl: MAATRA_VIDEO_URL },
  ];

  return (
    <ExploreScreen
      pill={t('auth.hospitalisation.pill')}
      bodyText={t('auth.hospitalisation.bodyText')}
      cards={cards}
    />
  );
};

export default Hospitalisation;
